import React from 'react';
import clsx from 'clsx';
import { OutlineButton } from '../../../buttons/index.js';
import { formatBytes } from '../../helper.js';
import 'tslib';
import './../../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../../util/Visible/Visible.js';
import Spacer from '../../../util/Spacer/Spacer.js';
import ProgressBarContainer from '../ProgressBar/ProgressBarContainer.js';
import cloudImage from './cloud-computing.png.js';
import { cssProcessingZone, cssProcessingZoneProgressBar, cssProcessing, cssProcessingTitle, cssProcessingUploadingTitle, cssProcessingInfo, cssProcessingPercentage, cssProcessingPercentageValue, cssProcessingButton } from './ProcessingZone.css.js';
import { cssCloudImage } from '../../index.css.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var ProcessingZoneComponent = function (_a) {
    var _b;
    var title = _a.title, _c = _a.cancelBtnLabel, cancelBtnLabel = _c === void 0 ? 'Cancel' : _c, progressConfig = _a.progressConfig, areFilesUploading = _a.areFilesUploading, totalFileSize = _a.totalFileSize, onCancel = _a.onCancel, setProgressConfig = _a.setProgressConfig;
    return (React.createElement("div", { className: "c-processing-zone ".concat(cssProcessingZone) },
        React.createElement(Visible, { when: !areFilesUploading },
            React.createElement(ProgressBarContainer, { className: "c-processing-zone__progress-bar ".concat(cssProcessingZoneProgressBar), progressConfig: progressConfig, setProgress: setProgressConfig })),
        React.createElement("div", { className: "c-processing ".concat(cssProcessing) },
            React.createElement(Visible, { when: areFilesUploading },
                React.createElement("img", { "data-testid": 'upload-in-progress-image', className: "c-cloud-image ".concat(cssCloudImage), src: cloudImage }),
                React.createElement(Spacer, { bottom: 20 })),
            React.createElement("div", { "data-testid": 'processing-title', className: clsx((_b = {},
                    _b[cssProcessingTitle] = !areFilesUploading,
                    _b[cssProcessingUploadingTitle] = areFilesUploading,
                    _b)) }, title),
            React.createElement(Spacer, { top: 27 }),
            React.createElement(Visible, { when: areFilesUploading },
                React.createElement("div", { "data-testid": 'processing-info', className: cssProcessingInfo }, "( ".concat(formatBytes(totalFileSize), " )"))),
            React.createElement(Visible, { when: !areFilesUploading },
                React.createElement("div", { className: cssProcessingPercentage },
                    React.createElement("span", { className: cssProcessingPercentageValue }, progressConfig === null || progressConfig === void 0 ? void 0 : progressConfig.progress),
                    React.createElement("span", null, "%")),
                React.createElement(Spacer, { bottom: 40 }),
                React.createElement(OutlineButton, { "data-testid": 'processing-button', onClick: onCancel, className: cssProcessingButton }, cancelBtnLabel)))));
};

export { ProcessingZoneComponent as default };
//# sourceMappingURL=ProcessingZoneComponent.js.map
